
import Vue, { PropType } from "vue";
import { TenantUser } from "@/models";

export default Vue.extend({
  name: "TenantUserListItem",

  props: {
    tenantUser: Object as PropType<TenantUser>
  },
  methods: {
    showDeleteScreen(): void {
      this.$router.push({
        name: "company-tenant-user-delete",
        params: {
          tenantUserId: this.tenantUser.id as string
        }
      });
    }
  },
  computed: {
    websitesText(): string {
      return (
        this.tenantUser?.websites?.map(w => w.displayName).join(", ") || ""
      );
    },
  }
});
